/** /admin "Sidebar" tab — SPN004 switches sidebar entries on/off (user decision 2026-09-28). */
export const navToggles: Record<string, string> = {
  'navToggles.tab': 'Sidebar',
  'navToggles.title': 'Bật/tắt mục trong sidebar',
  'navToggles.help':
    'Tắt một mục nghĩa là mục đó biến mất khỏi sidebar VÀ trang của nó bị chặn với mọi người — kể cả admin toàn hệ thống, CEO/CMO — trừ bạn (SPN004). Bạn vẫn thấy mục đã tắt (có nhãn "Đã tắt") và mở thử được trước khi bật lại.',
  'navToggles.footerGroup': 'Chân sidebar',
  'navToggles.offBadge': 'Đã tắt',
  'navToggles.saved': 'Đã lưu.',

  // Popup "ai dùng được mục này" + phân quyền theo người (user decision 28/09/2026).
  'navAudience.open': 'Người dùng',
  'navAudience.loadError': 'Không tải được danh sách người dùng.',
  'navAudience.saved': 'Đã lưu. API áp dụng ngay.',
  'navAudience.offNote': 'Mục này đang TẮT: hiện chỉ bạn mở được. Danh sách dưới đây là những người sẽ dùng được khi bật lại.',
  'navAudience.employees': 'Nhân viên dùng được',
  'navAudience.search': 'Tìm tên, mã, phòng…',
  'navAudience.externals': 'Tài khoản ngoài',
  'navAudience.externalsHelp': 'Tài khoản đăng nhập được nhưng không có hồ sơ nhân sự đang làm việc. Chỉ xem.',
  'navAudience.effectNote': 'API chặn/mở ngay ở request kế tiếp; sidebar của người đó cập nhật khi họ tải lại trang.',
  'navAudience.pickEmployee': '— Chọn nhân viên —',
  'navAudience.add': 'Thêm',
  'navAudience.remove': 'Bỏ',
  'navAudience.listEmpty': 'Danh sách trống — không ai được vào theo danh sách.',
  'navAudience.list.moLead': 'Danh sách được vào trang Lead MO (ngoài Lead MONET)',
  'navAudience.list.gameAdmin': 'Danh sách quản trị game (/game/admin)',
  'navAudience.list.admobBlock': 'Executor chặn app trên AdMob (duyệt và chạy yêu cầu; chỉ admin; mặc định SPN004)',
  'navAudience.list.notAdmin': 'không phải admin',
  'navAudience.list.notAdminHelp': 'Không phải admin nên không dùng được tính năng này và không nhận thông báo của nó. Bỏ khỏi danh sách, hoặc cấp lại quyền admin cho người này.',
  'navAudience.reason.admin': 'Admin',
  'navAudience.reason.override': 'Cấp riêng',
  'navAudience.reason.list': 'Theo danh sách',
  'navAudience.reason.rule': 'Theo HR',
  'navAudience.link.appPermissions': 'Quyền theo app: quản lý ở App Permissions',
  'navAudience.link.devPermissions': 'Admin: quản lý ở Dev Permissions',
  'navAudience.adminOnly': 'chỉ admin mở được',
  'navAudience.link.gadsEditor': 'Quản lý danh sách ở Campaign Editor',
  'navAudience.link.monetEditors': 'Quản lý ở tab Monet editors',
  'navAudience.source.devPermission': 'Dev Permissions',
  'navAudience.source.loginAllowlist': 'Danh sách đăng nhập',
  'navAudience.source.admobAllowlist': 'Danh sách AdMob',
  'navAudience.source.gadsEditor': 'Campaign Editor',
  'navAudience.source.signedIn': 'Đã từng đăng nhập',
  'navAudience.key.all': 'Mọi người đăng nhập',
  'navAudience.key.employee': 'Nhân viên',
  'navAudience.key.admin': 'Admin',
  'navAudience.key.ua': 'UA/DA',
  'navAudience.key.localize': 'UA (không gồm DA)',
  'navAudience.key.monet': 'Monet',
  'navAudience.key.dev': 'Developer report',
  'navAudience.key.devDept': 'Phòng DEV',
  'navAudience.key.hr': 'HR',
  'navAudience.key.hrLead': 'HR Lead',
  'navAudience.key.aso': 'ASO',
  'navAudience.key.cto': 'CTO',
  'navAudience.key.cmo': 'CMO',
  'navAudience.key.designLead': 'Lead Design',
  'navAudience.key.monetLead': 'Lead Monet',
  'navAudience.key.monetAssign': 'Monet editors',
  'navAudience.key.creativeSpy': 'Creative Spy',
  'navAudience.key.gadsEditor': 'Campaign Editor',
  'navAudience.key.commission': 'Hoa hồng',
  'navAudience.key.gamePlayer': 'Người chơi game',
  'navAudience.key.moLead': 'Lead MO',
  'navAudience.key.toggleNav': 'SPN004',
  'navAudience.tickHelp': 'Tick = dùng được trang này. Tick/bỏ tick từng người hoặc cả phòng, rồi bấm Lưu. Chỉ áp dụng cho trang này; thu quyền áp cả với admin; SPN004 luôn giữ quyền.',
  'navAudience.noDept': '(Không phòng ban)',
  'navAudience.locked': 'Luôn giữ',
  'navAudience.rule.deptGrant': 'Cấp cả phòng',
  'navAudience.rule.deptRevoke': 'Thu cả phòng',
  'navAudience.rule.personGrant': 'Cấp riêng',
  'navAudience.rule.personRevoke': 'Thu riêng',
  'navAudience.keyOverridesNote': 'Có quyền riêng theo key (cơ chế cũ) đang thu quyền của',
  'navAudience.noChanges': 'Chưa có thay đổi.',
  'navAudience.summary.grant': 'Cấp',
  'navAudience.summary.revoke': 'Thu',
  'navAudience.summary.removed': 'Bỏ luật riêng của',
  'navAudience.reset': 'Hoàn tác',
  'navAudience.editRightNote': 'Trang quản trị dữ liệu gốc: tick ở đây là quyền SỬA (thêm/sửa/xoá), không chỉ xem.',
  'navAudience.siblingNote': 'Dùng chung API với các mục khác của cùng công cụ — muốn chặn hẳn API thì bỏ tick ở cả',
}
